import { useQuery } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { challengesService } from 'src/services/challenges.service'

export const useGetChallangeInfo = (id: string, enabled: boolean) => {
  return useQuery([QUERY_KEYS.CHALLENGE_INFO, id], () => challengesService.getChallengeInfo(id), {
    refetchOnWindowFocus: true,
    keepPreviousData: false,
    enabled,
  })
}
